import { render, staticRenderFns } from "./social-report.vue?vue&type=template&id=eee0925a&scoped=true"
import script from "./social-report.vue?vue&type=script&lang=js"
export * from "./social-report.vue?vue&type=script&lang=js"
import style0 from "./social-report.vue?vue&type=style&index=0&id=eee0925a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eee0925a",
  null
  
)

export default component.exports